import React from 'react';
import _ from 'lodash';
import { translate } from '@fiverr-private/i18n-react';
import {
    Faqs,
    Tips,
    type TipsData,
    RelatedGuides,
    RelatedLinks,
    type RelatedLinksData,
} from '@fiverr-private/seo_content';
import { BRAND_STYLE_GUIDE_SC_SLUG } from '../../../utils/constants';
import { RelatedSkills } from './components/RelatedSkills';
import './index.scss';

interface SeoSubCategoryProps {
    title: string;
    faqs?: { question: string; answer: string }[];
    answersLink?: string;
    relatedLinksTitle?: string;
    relatedLinks?: RelatedLinksData;
    relatedSkillsTitle?: string;
    relatedSkillsLinks?: { url: string; text: string; openInNewTab: boolean }[];
    // houston/builder format mapping
    relatedGuides?: (
        | { title: string; article_link: string; image_link: string; image_alt: string }
        | { guideTitle: string; guideUrl: string; imageUrl: string; imageAlt: string }
    )[];
    seeMoreText?: string;
    seeMoreLink?: string;
    cachedSlug: string;
    tips?: TipsData;
}

const SeoSubCategory = ({
    title,
    faqs = [],
    answersLink,
    relatedLinksTitle = '',
    relatedLinks = { items: [] },
    relatedSkillsTitle = '',
    relatedSkillsLinks = [],
    relatedGuides = [],
    seeMoreText = '',
    seeMoreLink = '',
    cachedSlug,
    tips,
}: SeoSubCategoryProps) => {
    const relatedGuidesSourcePageKey = `subcategories_${cachedSlug}`;
    const relatedGuidesTitle =
        cachedSlug === BRAND_STYLE_GUIDE_SC_SLUG
            ? translate('search_perseus.seo_sub_category.related_guides.brand_style_guides_title')
            : translate('search_perseus.seo_sub_category.related_guides.title', {
                  params: { sub_category_title: title },
              });

    const mappedRelatedGuides = relatedGuides?.map((guide) => ({
        guideTitle: 'guideTitle' in guide ? guide.guideTitle : guide.title,
        guideUrl: 'guideUrl' in guide ? guide.guideUrl : guide.article_link,
        imageUrl: 'imageUrl' in guide ? guide.imageUrl : guide.image_link,
        imageAlt: 'imageAlt' in guide ? guide.imageAlt : guide.image_alt,
    }));

    return (
        <>
            {!_.isEmpty(tips) && <Tips data={tips} subCategory={title} />}
            {!_.isEmpty(relatedLinks.items) && <RelatedLinks title={relatedLinksTitle} relatedLinks={relatedLinks} />}
            {!_.isEmpty(relatedSkillsLinks) && (
                <RelatedSkills title={relatedSkillsTitle} relatedSkillsLinks={relatedSkillsLinks} />
            )}
            {!_.isEmpty(faqs) && <Faqs title={title} faqs={{ items: faqs }} answersLink={answersLink} />}
            {!_.isEmpty(relatedGuides) && (
                <RelatedGuides
                    guides={{ items: mappedRelatedGuides }}
                    seeMoreText={seeMoreText}
                    seeMoreLink={seeMoreLink}
                    title={relatedGuidesTitle}
                    sourcePageKey={relatedGuidesSourcePageKey}
                />
            )}
        </>
    );
};

export default SeoSubCategory;
